import React from 'react';
import { SmallUnderline } from "../../styles/components/SmallUnderline";
import { Row, Col, Container } from 'reactstrap';

export class SectionHeader extends React.Component {

  constructor(props) {
    super(props);

    let align;

    switch(this.props.align){
      case "right":
        align = "flex-end";
        break;
      case "left":
        align = "flex-start";
        break;
      case "flex-end":
      case "flex-start":
      case "center":
        align = this.props.align;
        break;
      default:
        align = "center";
    }

    this.alignment = {
      "alignItems": align
    };

    this.color = {
      backgroundColor: this.props.color
    }
  }

  render(){
    return (
      <div className={ "section-header " + this.props.className} style={ this.color }>
        <Container>
          <Row>
            <Col xs="12" md={{ size: 8, offset: 2 }}>
              <SmallUnderline align={this.props.align}>
                <h2 className={ "text-" + this.props.align }>{ this.props.title }</h2>
              </SmallUnderline>
              {
                this.props.subtitle !== undefined &&
                <p className={ "pt-4 text-" + this.props.align }>{ this.props.subtitle }</p>
              }
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

SectionHeader.defaultProps = {
  color: '#F5F6F8'
};



// WEBPACK FOOTER //
// ./src/components/section-header/SectionHeader.js